module.exports = __webpack_public_path__ + "static/media/phoenix_red.a27f6260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/phoenix_red.svg
// module id = 57
// module chunks = 0